import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { DatePicker, Input } from 'antd';
import moment from 'moment';
import { stylesFilter } from './styles';
import { StatesListSelectors } from '../../../../store/selectors/statesListSelectors';
import { RegionsListSelectors } from '../../../../store/selectors/regionsListSelectors';
import { CarriersListSelectors } from '../../../../store/selectors/carriersListSelectors';
import { getStatesList } from '../../../../store/actions/statesList/statesList';
import { getRegionsList } from '../../../../store/actions/regionsList/regionsList';
import { getCarriersList } from '../../../../store/actions/carriersList/carriersList';
import { Defines } from '../../../../project/Defines';

const Filters = ({ resource, page, handleSelectChange, stateFilterOptions, statePagination, load }) => {
    const dispatch = useDispatch();
    const { statesList } = StatesListSelectors();
    const { regionsList } = RegionsListSelectors();
    const { carriersList } = CarriersListSelectors();

    const [collapseState, toggleCollapseState] = useState(false);
    const [loadType, setLoadType] = useState(null);
    const [state, setState] = useState(null);
    const [region, setRegion] = useState(null);
    const [carrier, setCarrier] = useState(null);
    const [selectedPickDate, setSelectedPickDate] = useState(null);
    const [selectedDropDate, setSelectedDropDate] = useState(null);

    const countryStateListURL = 'Location/statekeyvaluelist';
    const countryIdUSA = 234;

    const loadTypeOptions = [
        { value: 1, label: 'Inbound Loads' },
        { value: 3, label: 'Outbound Loads' },
        { value: null, label: 'All Loads' },
    ];

    useEffect(() => {
        if (!statesList?.length) {
            dispatch(getStatesList(countryStateListURL, countryIdUSA));
        }
        if (!regionsList?.data?.length) {
            dispatch(getRegionsList('region'));
        }
        if (!carriersList?.data?.length) {
            dispatch(getCarriersList('carrierForAdmin'));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getLabelByValue = useCallback(value => {
        if (value === 1) {
            return 'Inbound Loads'
        } else if (value === 3) {
            return 'Outbound Loads'
        } else {
            return 'All Loads'
        }
    }, [])

    const statesOptions = statesList?.map((state) => ({
        value: state.value,
        label: state.text,
    })).concat({ value: 'All', label: 'All' }) || [];

    const regionsOptions = regionsList?.data?.map((region) => ({
        value: region.id,
        label: region.name,
    })).concat({ value: 'All', label: 'All' }) || [];

    const carriersOptions = carriersList?.data?.map((carrier) => ({
        value: carrier.id,
        label: carrier.name,
    })).concat({ value: 'All', label: 'All' }) || [];

    const handleChangeLoadType = option => {
        handleSelectChange(option.value, 'loadType');
        setLoadType(option);
    };

    const handleChangePickDate = option => {
        if (option === null) {
            handleSelectChange(null, 'pickAppointment');
            setSelectedPickDate(null);
        } else {
            const date = moment(option, Defines.Format.PrintDate).format(Defines.Format.PrintDate);
            handleSelectChange(date, 'pickAppointment');
            setSelectedPickDate(date);
        }
    };

    const handleChangeDropDate = option => {
        if (option === null) {
            handleSelectChange(null, 'dropAppointment');
            setSelectedDropDate(null);
        } else {
            const date = moment(option, Defines.Format.PrintDate).format(Defines.Format.PrintDate);
            handleSelectChange(date, 'dropAppointment');
            setSelectedDropDate(date);
        }
    };

    const handleChangeStateName = option => {
        console.log('option', option)
        handleSelectChange(option, 'state');
        setState(option);
    };

    const handleChangeRegions = option => {
        handleSelectChange(option, 'region');
        setRegion(option);
    };

    const handleChangeCarriers = option => {
        handleSelectChange(option, 'carrier');
        setCarrier(option);
    };

    const handleChangeMCNumber = option => {
        handleSelectChange(option, 'mcNumber');
    };

    const handleChangeDOTNumber = option => {
        handleSelectChange(option, 'dotNumber');
    };

    const clearAllFilters = () => {
        handleSelectChange('', 'default');
        setLoadType(null);
        setSelectedPickDate(null);
        setSelectedDropDate(null);
        setState(null);
        setCarrier(null);
        setRegion(null);

        const emptyPayload = {
            "page": 1,
            "pageSize":  4,
            "loadType": null,
            "regionId": null,
            "stateId": null,
            "carrierId": null,
            "mcNumber": null,
            "dotNumber": null,
            "searchText": null,
            "pickAppointment": null,
            "dropAppointment": null,
        };
        dispatch(load(resource, page, emptyPayload, statePagination, 'withoutLoading'));
    };

    const apply = () => {
        dispatch(load(resource, page, stateFilterOptions, statePagination, 'withoutLoading'));
    }

    const handleCollapseClick = () => {
        toggleCollapseState(!collapseState);
    };

    return (
        <div style={{display: 'flex', flexDirection: 'column', borderRight: '1px solid lightgray' }}>
            <div className={`${collapseState ? 'show_collapse' : 'hide_collapse'} filters_container__collapse filter-search-container`}>
                <div className='filters__inner-container__collapse'>
                    <div className={`${collapseState ? 'filter-title__collapse__container__large' : ''} filter-title__collapse__container `} onClick={() => handleCollapseClick()} >
                        <div 
                            className={`${collapseState ? 'large_title' : 'small_title'} filter-title__collapse`}>
                            Filters
                        </div>
                    </div>
                    <div className='horizontal-line'></div>
                    <div className={`${collapseState ? '' : 'hide-all-filters'} filter_container__select select__collapse`}>
                        <div className='select-title__collapse'>Load Type</div>
                        <Select
                            options={loadTypeOptions}
                            name="loadType"
                            placeholder={getLabelByValue(stateFilterOptions?.loadType)}
                            value={loadType && loadType?.label}
                            className='filter_pick'
                            noOptionsMessage={() => null}
                            onChange={option => handleChangeLoadType(option)}
                            styles={stylesFilter}
                            menuPortalTarget={document.body}
                        />
                    </div>
                    <div className={`${collapseState ? '' : 'hide-all-filters'} filter_container__select select__collapse`}>
                        <div className='select-title__collapse'>State</div>
                        <Select
                            options={statesOptions}
                            name="stateName"
                            placeholder = "State"
                            value={state ? state : stateFilterOptions.state}
                            className='filter_pick'
                            noOptionsMessage={() => null}
                            onChange={option => handleChangeStateName(option)}
                            styles={stylesFilter}
                            menuPortalTarget={document.body}
                        />
                    </div>
                    <div className={`${collapseState ? '' : 'hide-all-filters'} filter_container__select select__collapse`}>
                        <div className='select-title__collapse'>Region</div>
                        <Select
                            options={regionsOptions}
                            name="region"
                            placeholder="Region"
                            value={region ? region : stateFilterOptions.region}
                            className='filter_pick'
                            noOptionsMessage={() => null}
                            onChange={option => handleChangeRegions(option)}
                            styles={stylesFilter}
                            menuPortalTarget={document.body}
                        />
                    </div>
                    <div className={`${collapseState ? '' : 'hide-all-filters'} filter_container__select select__collapse`}>
                        <div className='select-title__collapse'>Carrier</div>
                        <Select
                            options={carriersOptions}
                            name="carrier"
                            placeholder="Carrier"
                            value={carrier ? carrier : stateFilterOptions.carrier}
                            className='filter_pick'
                            noOptionsMessage={() => null}
                            onChange={option => handleChangeCarriers(option)}
                            styles={stylesFilter}
                            menuPortalTarget={document.body}
                        />
                    </div>
                    <div className={`${collapseState ? '' : 'hide-all-filters'} filter_container__select select__collapse`}>
                        <div className='select-title__collapse'>MC#</div>
                        <Input
                            className='stop__input'
                            onChange={e => handleChangeMCNumber(e.target.value.toLowerCase())}
                            value={stateFilterOptions.mcNumber}
                            placeholder="MC#"
                            type="number"
                        /> 
                    </div>
                    <div className={`${collapseState ? '' : 'hide-all-filters'} filter_container__select select__collapse`}>
                        <div className='select-title__collapse'>DOT#</div>
                        <Input
                            className='stop__input'
                            onChange={e => handleChangeDOTNumber(e.target.value.toLowerCase())}
                            value={stateFilterOptions.dotNumber}
                            placeholder="DOT#"
                            type="number"
                        /> 
                    </div>
                    <div className={`${collapseState ? '' : 'hide-all-filters'} filter_container__select select__collapse`}>
                        <div className='select-title__collapse'>Pick APPT</div>
                        <DatePicker 
                            onChange={handleChangePickDate}
                            value={selectedPickDate ? moment(selectedPickDate, Defines.Format.PrintDate) : stateFilterOptions.pickAppointment ? moment(stateFilterOptions.pickAppointment, Defines.Format.PrintDate) : ''}
                            className='custom-datepicker__callCheckLoads'
                        />
                    </div>
                    <div className={`${collapseState ? '' : 'hide-all-filters'} filter_container__select select__collapse`}>
                        <div className='select-title__collapse'>Drop APPT</div>
                        <DatePicker 
                            onChange={handleChangeDropDate}
                            value={selectedDropDate ? moment(selectedDropDate, Defines.Format.PrintDate) : stateFilterOptions.dropAppointment ? moment(stateFilterOptions.dropAppointment, Defines.Format.PrintDate) : ''}
                            className='custom-datepicker__callCheckLoads'
                        />
                    </div>
                </div>
                <div className={`${collapseState ? 'show_collapse' : 'hide-collapse hide-all-filters'}`}>
                    <div className='filter_container__select stops-filter-checkbox_container'>
                        <div onClick={() => clearAllFilters()} className='filters__clear-all'>Clear All</div>
                        <div onClick={() => apply()}>Apply</div>
                    </div>
                </div>
            </div>
        </div>
        );
};

export default Filters;